import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { TituloReceberFilter } from '../../filter';
import { perspectivaVencidos } from '../../perspectiva';
import { TituloReceberSearchCliente } from '../titulo-receber-search-cliente';
import { TituloReceberSearchTotalCliente } from '../titulo-receber-search-total-cliente';

@Injectable({
    providedIn: 'root'
})
export class TituloReceberSearchClienteHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/tituloreceber/0/cliente`;
    }

    /** Realizada a pesquisa os títulos a receber agrupados por clientes */
    search(filter: TituloReceberFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<TituloReceberSearchCliente[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<TituloReceberSearchCliente[]>(this.pathApi, {params});
    }

    /** Obtem os totais da pesquisa dos títulos receber agrupados por clientes */
    getTotais(filter: TituloReceberFilter): Observable<TituloReceberSearchTotalCliente> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<TituloReceberSearchTotalCliente>(`${this.pathApi}/total`, {params});
    }

    /** Realizada a pesquisa os títulos a receber vencidos agrupados por clientes */
    searchVencidos(filter: TituloReceberFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<TituloReceberSearchCliente[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        // Sempre perspectiva de títulos vencidos
        params = params.delete('perspectiva').append('perspectiva', perspectivaVencidos.id.toString());

        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<TituloReceberSearchCliente[]>(this.pathApi, {params});
    }

    /** Obtem os totais da pesquisa dos títulos receber vencidos agrupados por clientes */
    getTotaisVencidos(filter: TituloReceberFilter): Observable<TituloReceberSearchTotalCliente> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        // Sempre perspectiva de títulos vencidos
        params = params.delete('perspectiva').append('perspectiva', perspectivaVencidos.id.toString());

        return this.customHttp.get<TituloReceberSearchTotalCliente>(`${this.pathApi}/total`, {params});
    }
}
